import { render, staticRenderFns } from "./BaseTableLoader.vue?vue&type=template&id=ad4f6b28&scoped=true&"
import script from "./BaseTableLoader.vue?vue&type=script&lang=js&"
export * from "./BaseTableLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4f6b28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VFadeTransition,VSkeletonLoader})
